module.exports = __webpack_public_path__ + "fa400f8120ee7b8a3c2e7d37e1baae12.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/report/senior_report/assets/B+@2x.png
// module id = 803
// module chunks = 0